export const formBuilder = ( formSkema ) =>
  formSkema.reduce( (obj,itm) => 
    ({...obj, [itm['name']]: null}) , {}
  )

export const buildRow = (infoRow) =>
  Object.keys(infoRow).map ( (key, idx) => (
    { value: infoRow[key] }
  ) )